var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.984 11.307a.661.661 0 100 1.323.661.661 0 000-1.323z",
    fill: "#6A737D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.158 12.39a.454.454 0 10-.348-.84.454.454 0 00.348.84zm-.174-.421zm0 0zm-.367-.55a.661.661 0 11.735 1.1.661.661 0 01-.735-1.1z",
    fill: "#6A737D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.969 11.307a.661.661 0 100 1.323.661.661 0 000-1.323z",
    fill: "#6A737D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.143 12.39a.454.454 0 10-.348-.84.454.454 0 00.348.84zm-.174-.421zm0 0zm-.368-.55a.661.661 0 11.735 1.099.661.661 0 01-.735-1.099z",
    fill: "#6A737D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.535 9.55a2.418 2.418 0 100 4.838h8.93a2.419 2.419 0 000-4.838h-8.93zm-2.5-.08a3.535 3.535 0 012.5-1.036h8.93a3.535 3.535 0 010 7.07h-8.93a3.535 3.535 0 01-2.5-6.035z",
    fill: "#6A737D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.612.496h6.777a2.543 2.543 0 012.475 1.962l2.042 8.704a.558.558 0 11-1.086.255l-2.043-8.704a1.427 1.427 0 00-1.388-1.1H4.612a1.427 1.427 0 00-1.39 1.1L1.18 11.417a.558.558 0 01-1.087-.255l2.043-8.704A2.543 2.543 0 014.612.496z",
    fill: "#6A737D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.977 11.969c0-.308.25-.558.558-.558h2.48a.558.558 0 010 1.116h-2.48a.558.558 0 01-.558-.558z",
    fill: "#6A737D"
  })));
}
export default SvgIconShares;